"use client";

import { useTranslations } from "next-intl";

const ROW_KEYS = [
	"capabilitiesRow1",
	"capabilitiesRow2",
	"capabilitiesRow3",
	"capabilitiesRow4",
	"capabilitiesRow5",
	"capabilitiesRow6",
	"capabilitiesRow7",
	"capabilitiesRow8",
] as const;

export default function DieCastingCapabilities() {
	const t = useTranslations("new-die-casting");

	return (
		<section className="bg-[#f9f9f2] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
						{t("capabilitiesTitle")}
					</h2>
				</header>

				<div className="overflow-x-auto">
					<table className="w-full min-w-[640px] border-collapse">
						<thead>
							<tr className="border-b border-[#d8d8c8]">
								<th className="w-1/3 py-4 pl-6 pr-4 text-left text-sm font-bold text-black md:py-5 md:pl-8 md:text-base">
									{t("capabilitiesColDetails")}
								</th>
								<th className="py-4 pl-4 text-left text-sm font-bold text-black md:py-5 md:text-base">
									{t("capabilitiesColInformation")}
								</th>
							</tr>
						</thead>
						<tbody>
							{ROW_KEYS.map((rowKey) => (
								<tr key={rowKey} className="border-b border-[#c1c1c1]">
									<td className="py-4 pl-6 pr-4 align-top text-sm font-bold text-black md:py-5 md:pl-8 md:text-base">
										{t(`${rowKey}Label`)}
									</td>
									<td className="py-4 pl-4 align-top text-sm leading-relaxed text-black md:py-5 md:text-base">
										{t(`${rowKey}Value`)}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
		</section>
	);
}
